<div class="container-modal-lateral">
  <div>
    <span class="title-modal-lateral">{{ visualizar ? 'Detalhes Pesquisa' : 'Cadastrar Pesquisa' }}</span>

    @if(!visualizar){
      <form [formGroup]="formGroupPesquisa" (ngSubmit)="salvar()">
        <div class="main-modal-lateral-edicao">
          <div class="container-edicao-modal-lateral">
            <app-slide-toggle-padrao [valor]="pesquisa.ativo" (changeValue)="pesquisa.ativo = $event; alteracaoService.camposAlterado()"></app-slide-toggle-padrao>
            <app-form-field formControlName="titulo" label="Título" heightFormField="35px" (changeValue)="alteracaoService.camposAlterado()"></app-form-field>
            <app-form-field formControlName="descricao" label="Descrição" heightFormField="35px" (changeValue)="alteracaoService.camposAlterado()"></app-form-field>
          </div>
        </div>
      </form>
    } @else {
      <div class="main-modal-lateral-info">
        <div class="container-info-modal-lateral">
          <span class="label">Status</span>
          <span class="font-12 ellipse">{{ pesquisa.ativo ? 'Ativo' : 'Inativo' }}</span>
        </div>

        <div class="container-info-modal-lateral">
          <span class="label">Título</span>
          <span class="font-12 ellipse">{{ pesquisa.titulo }}</span>
        </div>

        <div class="container-info-modal-lateral">
          <span class="label">Descrição</span>
          <span class="font-12 ellipse">{{ pesquisa.descricao }}</span>
        </div>
      </div>
    }
  </div>

  @if(!visualizar){
    <div class="botoes-modal-lateral">
      <app-button-padrao
        width="100%"
        label="Salvar"
        backgroundColor="var(--verde-padrao)"
        color="white"
        [backgroundColor]="formGroupPesquisa.invalid ? 'grey' : 'var(--verde-padrao)'"
        [color]="formGroupPesquisa.invalid ? 'dark-grey' : '#FFF'"
        [type]="'submit'"
        [disabled]="formGroupPesquisa.invalid"
        (buttonClick)="salvar()">
      </app-button-padrao>
      <app-button-padrao
        width="100%"
        label="Cancelar"
        backgroundColor="white"
        color="var(--vermelho-padrao)"
        (buttonClick)="cancelar()"
        borderColor="var(--vermelho-padrao)"
        borderStyle="solid"
        borderWidth="1px">
      </app-button-padrao>
    </div>
  }
</div>
